ConfirmationModal = require 'components/common/confirmation_modal'
ConnectStore = require 'components/enhancers/connect_store'
EtdStore = require 'stores/etd_store'
mediator = require 'mediator'
{ hasJustificationSection, isAiRecommendationGenerationSupported } =
  require 'lib/recommendation_mapper'
{ useState } = React
{ useCoffeeCallback, useI18n } = require 'lib/react_utils'

storeConnectors =
  EtdStore: (Store) ->
    template = Store.getState().get 'template', Immutable.Map()
    etdDoc = template.toJS()
    questionId: template.getIn ['templateData', 'question', 'docId']
    recommendationId: Store.getEtdId()
    hasJustification: hasJustificationSection etdDoc
    isSupported: isAiRecommendationGenerationSupported etdDoc

GenerateRecommendationButton = ({
  editable
  hasJustification
  isConsensus
  isSupported
  questionId
  recommendationId
}) ->
  i18n = useI18n 'es:recommendations'
  [isModalOpen, setIsModalOpen] = useState false
  [isLoading, setIsLoading] = useState false

  showButton = mediator.services.switches.isOn('aiRecommendationGeneration') and
    editable and
    isSupported and
    questionId?

  onOpenModal = useCoffeeCallback [isLoading], ->
    return if isLoading
    setIsModalOpen true

  onCloseModal = useCoffeeCallback [isLoading], ->
    return if isLoading
    setIsModalOpen false

  onConfirm = useCoffeeCallback [questionId, recommendationId, isConsensus, i18n], ->
    setIsLoading true
    mediator.services.aiService.generateRecommendationForQuestion questionId, {
      isConsensus
      recommendationId
    }
    .then ->
      mediator.dialogs.success i18n 'generate_ai_recommendation.success'
    .catch (error) ->
      mediator.dialogs.error error?.message or i18n 'generate_ai_recommendation.error'
    .finally ->
      setIsLoading false
      setIsModalOpen false

  confirmationMessage = if hasJustification
    i18n 'generate_ai_recommendation.confirmation_message'
  else
    i18n 'generate_ai_recommendation.confirmation_message_recommendation_only'

  buttonLabel = i18n 'generate_ai_recommendation.button'

  <React.Fragment>
    {showButton and
      <button
        className="btn btn-add generate-ai-recommendation"
        disabled={isLoading or not editable}
        onClick={onOpenModal}
        title={buttonLabel}
        type="button"
      >
        {buttonLabel}
      </button>
    }
    <ConfirmationModal
      cancelLabel={i18n '/actions.cancel'}
      confirmLabel={i18n 'generate_ai_recommendation.confirmation_apply'}
      isCancelEnabled={not isLoading}
      isOpen={isModalOpen}
      loading={isLoading}
      message={confirmationMessage}
      onCancel={onCloseModal}
      onConfirm={onConfirm}
      question={i18n 'generate_ai_recommendation.confirmation_question'}
      title={i18n 'generate_ai_recommendation.confirmation_title'}
    />
  </React.Fragment>

GenerateRecommendationButton.propTypes =
  editable: PropTypes.bool
  hasJustification: PropTypes.bool
  isConsensus: PropTypes.bool
  isSupported: PropTypes.bool
  questionId: PropTypes.string
  recommendationId: PropTypes.string

GenerateRecommendationButton.defaultProps =
  editable: false
  hasJustification: true
  isConsensus: false
  isSupported: false
  recommendationId: null

module.exports = ConnectStore GenerateRecommendationButton, [EtdStore], storeConnectors
